import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import AppContext from '../AppContext';
import { GetOrganizationSitesPayload } from './generated/types';

export interface SiteListItem {
    id: string;
    name: string;
    city: string;
    country: string;
    code: string;
    registration: string;
    contactPerson: string;
    contactEmail: string;
}

export const useGetOrganizationSites = (parentOrgId: string) => {
    const context = useContext(AppContext);

    const query = `query GetOrganizationSites($parentOrgId: ID!) {
      getOrganizationSites(parentOrgId: $parentOrgId) {
        items {
          id
          name
          city
          country
          code
          registration
          contactPerson
          contactEmail
        }
      }
    }`;

    return useQuery<Array<SiteListItem>, Error>({
        queryKey: ['getOrganizationSites', parentOrgId],
        queryFn: async () => {
            const response = await (context.api.graphql({ query, variables: { parentOrgId } }) as Promise<{
                data: {
                    getOrganizationSites: GetOrganizationSitesPayload;
                };
            }>);

            return response.data.getOrganizationSites.items.map((item) => {
                if (!item.id) {
                    throw new Error(`Site organization ${item.code} has no organization ID.`);
                }

                return {
                    id: item.id,
                    name: item.name,
                    city: item.city,
                    country: item.country,
                    code: item.code,
                    registration: item.registration,
                    contactPerson: item.contactPerson ?? '',
                    contactEmail: item.contactEmail,
                };
            });
        },
        enabled: !!parentOrgId,
    });
};
